import React, { useEffect, useRef, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useNavigate } from 'react-router-dom';

function BarChartRiegoProduccionEvolucion({ startCampana, endCampana, campanas, data, finca }) {

  const chartRef = useRef(null);
  const navigate = useNavigate();
  const [ chartInfo, setChartInfo ] = useState();
  
  useEffect(() => {
    chooseOption();
  }, [startCampana, endCampana]);

  useEffect(() => {
    const chart = chartRef.current;

    const handleClickCanvas = (event) => {

      const elements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
      if (elements.length === 0) {
        const canvasPosition = {
          x: event.offsetX,
          y: event.offsetY,
        };

        const dataXLabels = chart.scales.x.ticks;
        
        // Calcular la posición de las etiquetas en el eje X
        dataXLabels.forEach((label, index) => {
            const xLabelPosition = chart.scales.x.getPixelForTick(index);
            const labelWidth = 100; // Ancho aproximado de la etiqueta

            // Verificar si el clic está dentro del rango de la etiqueta
            if (canvasPosition.x >= xLabelPosition - labelWidth / 2 && canvasPosition.x <= xLabelPosition + labelWidth / 2) {

              let posElement = chart.data.labels.indexOf(label.label);
              let campana = chart.data.labels[posElement];

              let fincaAux;
              if(finca.fincas.length > 0){
                fincaAux = finca.fincas.find(s => {
                  if(s.dataType === "finca"){
                    return s.id;
                  }
                });
              }
              navigate(`/huella-cultivos/${fincaAux.id}`, {
                state: { sectorId: "all", campana: campana }
              });
            }
        });
      }
        
    };

    if (chart) {
        chart.canvas.addEventListener('click', handleClickCanvas);
    }

    return () => {
        if (chart?.canvas) {
            chart.canvas.removeEventListener('click', handleClickCanvas);
        }
    };
  }, [chartRef, chartInfo]);

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const generateCampanas = () => {
    const indiceInicio = campanas.indexOf(startCampana);
    const indiceFin = campanas.indexOf(endCampana);

    return campanas.slice(indiceInicio, indiceFin + 1);
  }

  const generateDataSets = (subData, labelsCampanas) => {
    
    //const sectorNames = Array.from(new Set(labelsCampanas.flatMap(campana => subData[campana].fincas.map(finca => finca.sectorName))));
    const sectores = Array.from(new Set(labelsCampanas.flatMap(campana => subData[campana].fincas)));

    const result = sectores.map(sector => {
      return {
        label: sector.sectorName,
        data: labelsCampanas.map(campaign => {
          const finca = subData[campaign].fincas.find(f => f.sector_id === sector.sector_id);
          return finca ? finca.produccion : 0;
        }),
        backgroundColor: getRandomColor(),
        sectorId: sector.sector_id,
        huellaId: sector.id,
      };
    });

    return result;
  
  }

  const chooseOption = () => {
    let subData = data.unidad.infoUnidad;

    const labelsCampanas = generateCampanas();

    const filteredData = Object.keys(subData)
    .filter((key) => labelsCampanas.includes(key))
    .reduce((obj, key) => {
      obj[key] = subData[key];
      return obj;
    }, {});

    let someData = Object.values(filteredData).some(c => {

      if(c.fincas.length !== 0){
        return true;
      }
      return false;
    });
    
    if(someData){
      const info = {
        labels: labelsCampanas,
        datasets: generateDataSets(filteredData, labelsCampanas)
      }
  
      setChartInfo(info);
    }else{
      setChartInfo();
    }

  }

  const handleClick = (event) => {
    const chart = chartRef.current;
    if (!chart) return;

    const elements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
    if (elements.length > 0) {

      const clickedDatasetIndex = elements[0].datasetIndex;
      const clickedHuella = chartInfo.datasets[clickedDatasetIndex].huellaId;
      const clickedSector = chartInfo.datasets[clickedDatasetIndex].sectorId;
      
      let fincaAux;
      if (finca.fincas.length > 0) {
        fincaAux = finca.fincas.find(s => s.dataType === "finca");
      }
      
      navigate(`/huella-cultivos/${fincaAux.id}`, {
        state: { sectorId: clickedSector, huellaId: clickedHuella }
      });
    } else {
      // DO NOTHING
    }
  };

  const options = {
    layout: {
      padding: {
          top: 0,
          bottom: 100,
      }
    },
    maintainAspectRatio: false,
    responsive: true,
    onClick: handleClick,
  };

    return (
      <>
        {chartInfo &&
          <>
              <div>
                <h3 style={{textAlign: "center", textDecoration: "underline", color: "#80C606", fontSize: "26px", marginBottom: "40px"}}>Producción por sectores (kg/ha)</h3>
                <div style={{minHeight: "600px"}}>
                  <Bar data={chartInfo} options={options} ref={chartRef}/>
                </div>
              </div>
          </>
        }
        {!chartInfo &&
          <p>No existe información disponible para el rango de campañas seleccionadas en el <b>gráfico de Producción por sectores (kg/ha)</b></p>
        }
      </>
    );
}

export default BarChartRiegoProduccionEvolucion;